import type {
  AppPageProps,
  RenderDocumentProps,
  RenderingStrategy,
  SlugPageProps,
} from '@/cms/rendering-strategy/types';
import * as React from 'react';
import { createConsoleLogger, PageComponent, Placeholder, UniformContextProvider } from '@uniformdev/next';
import { getBrandName } from '@/helpers/environment';
import { getFonts } from '@/framework/react-styles';

export function mvcRenderingStrategy(): RenderingStrategy {
  function renderDocument({ Html, Main, head, pageProps }: RenderDocumentProps) {
    const page = pageProps?.page;

    const metadata = pageProps?.metadata;
    const { name, template, fields } = page || {};
    const { bodyAttrs, htmlLang } = fields || {};
    const { machineName, staticFileName } = bodyAttrs || {};

    const brandName = getBrandName();
    const { primaryFont, secondaryFont } = getFonts(brandName);

    return (
      <Html lang={htmlLang}>
        <head>
          {head}
          {metadata?.title && <title>{metadata.title}</title>}
          {metadata?.faviconUrl && <link rel="shortcut icon" type="image/x-icon" href={metadata.faviconUrl} />}
        </head>
        <body
          className={`o-block o-block--stretch l-site t-${staticFileName} ${primaryFont.variable} ${secondaryFont.variable}`}
          data-in-name={machineName}
          data-qa-page={name}
          data-qa-template={template}
        >
          <Main />
        </body>
      </Html>
    );
  }

  function renderApp({ Component, pageProps }: AppPageProps) {
    return (
      <>
        <Component {...pageProps} />
      </>
    );
  }

  function renderPageComponent(pageProps: SlugPageProps) {
    return (
      <UniformContextProvider logger={createConsoleLogger()} componentMap={{}}>
        <PageComponent {...pageProps}>
          {(renderingContext) => <Placeholder placeholderKey="/" renderingContext={renderingContext} />}
        </PageComponent>
      </UniformContextProvider>
    );
  }

  return {
    type: 'mvc',
    renderDocument,
    renderApp,
    renderPageComponent,
  };
}
